module.exports = __webpack_public_path__ + "img/tick_square_2.edbd081d.svg";